import { render } from "./UploadShipmentLabel.vue?vue&type=template&id=faeac046&scoped=true&ts=true"
import script from "./UploadShipmentLabel.vue?vue&type=script&lang=ts"
export * from "./UploadShipmentLabel.vue?vue&type=script&lang=ts"

import "./UploadShipmentLabel.vue?vue&type=style&index=0&id=faeac046&lang=scss&scoped=true"
import "./UploadShipmentLabel.vue?vue&type=style&index=1&id=faeac046&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faeac046"]])

export default __exports__